// extracted by mini-css-extract-plugin
export default {"topoUser":"menuuser_topoUser__e3ssm","dropdownToggle":"menuuser_dropdownToggle__0dsMA"};